import { render, staticRenderFns } from "./MyService.vue?vue&type=template&id=6612a256&"
import script from "./MyService.vue?vue&type=script&lang=ts&"
export * from "./MyService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports